//Todo: Refactor, create small API ?

(function ($) {
    $.fn.stars = function (config) {
        config = config || {};

        return this.each(function(){
            var $input = $(this)
                , isReadOnly = !!$input.attr('readonly'),
                starConfig = $input.data('starconfig');

            $input.attr('hidden', true);

            var container = $('<div />', {
                class: 'stars-container'
            });

            container.insertAfter($input);

            container.on('mouseout', function () {
                container.find('.star:not(.permanent-selected)').removeClass('selected');
            });

            container.on('mouseover', '.star', function () {
                var $this = $(this);

                actIfEnabled(function () {
                    var highlightedStars = $this
                        .prevAll('.star')
                        .andSelf();

                    highlightedStars.addClass('selected');
                });
            });

            container.on('click', '.star', function () {
                var $this = $(this);

                actIfEnabled(function () {
                    container.find('.star.permanent-selected').removeClass('selected permanent-selected');

                    $this.trigger('mouseover');

                    var highlightedStars = container.find('.star.selected');
                    highlightedStars.addClass('permanent-selected')

                    $input.val(highlightedStars.length);
                });
            });

            var starCount = $input.attr('max') || $input.data('val-range-max') || 5;
            var currentStars = $input.val() - 1;

            for (var i = 0; i < starCount; i++) {
                var selectedClass = '';

                actIfEnabled(function () {
                    selectedClass = (i <= currentStars ? ' selected permanent-selected' : '');
                }, true);

                var attributes = {
                    'class': 'fa fa-2x fa-star star' + selectedClass
                };

                var icon = $('<i />', attributes);
                if (config.displayRating) {
                    var iconContainer = $('<span />', { 'class': 'fa-stack star' });
                    var ratingDisplay = $('<span>' + (i + 1) + '</span>');

                    icon.removeClass('fa-2x');
                    icon.addClass('fa-stack-2x');
                    ratingDisplay.addClass('fa-stack-1x');

                    iconContainer.append(icon);
                    iconContainer.append(ratingDisplay);

                    icon = iconContainer;
                }

                if(isReadOnly) {
                    icon.attr('readonly', 'readonly');
                }

                container.append(icon);
            }

            function actIfDisabled(fn) {
                if (input.prop('disabled')) {
                    fn();
                }
            }

            function actIfEnabled(fn, ignoreReadOnly) {
                if (!$input.prop('disabled') && (!isReadOnly || ignoreReadOnly)) {
                    fn();
                }
            }
        });
    }
}(jQuery));